export default __webpack_public_path__ + "static/media/photo--sm--gord.7f43ab7b.jpg";